module.exports = __webpack_public_path__ + "img/T5.c57422cb.png";